import { type RenderMark } from '@contentful/rich-text-react-renderer'
import { SuperscriptUI } from '@ui/superscript'
import React from 'react'

export const sup: RenderMark[string] = (text) => <SuperscriptUI value={text} />
